import _regeneratorRuntime from "/data/apd/jenkins/workspace/parenting-parent-page/node_modules/@babel/runtime/helpers/regeneratorRuntime.js";
import _asyncToGenerator from "/data/apd/jenkins/workspace/parenting-parent-page/node_modules/@babel/runtime/helpers/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/global/ok_icon.png';
import { ref, watch, reactive, onBeforeMount, computed } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
import ResponseBindApplyPopup from "./views/layout/components/responseBindApplyPopup.vue";
//@ts-ignore
import wx from "weixin-js-sdk";
import { applyList, applyDeal, jsapiSignature } from "@/services/user";
import { useMineStore, STORE_USERINFO_KEY } from "@/store/modules/mine";
import { Toast } from "vant";
import { storeToRefs } from 'pinia';
import { getStorage } from "@/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup: function setup(__props) {
    var mineStore = useMineStore();
    var _storeToRefs = storeToRefs(mineStore),
      accountInfo = _storeToRefs.accountInfo;
    var route = useRoute();
    var showApply = computed(function () {
      return mineStore.isShowApply;
    });

    // 监听申请待审核，弹出框审核，当路由为底部四个导航时显示
    var state = reactive({
      routes: ["/mine", "/pairedReading", "/check", "/record"],
      current_apply: null,
      //当前处理的申请
      applyBindList: [],
      // 账号关联申请列表
      dialogOption: {
        title: "申请已处理",
        message: "您可以在「我的」-「账号管理」-「家长管理」中查看申请记录",
        cancelText: "我知道了",
        sureText: "去查看"
      },
      params: null //申请列表参数
    });
    // 去看看
    var toLook = function toLook() {
      var _state$current_apply;
      close();
      router.push({
        path: "/applyBindRecord",
        query: {
          studentId: (_state$current_apply = state.current_apply) === null || _state$current_apply === void 0 ? void 0 : _state$current_apply.studentId,
          isAdmin: 1
        }
      });
    };
    // 弹出窗口
    var dialog = ref(null);
    // 审核后提示
    var tip = ref(null);
    // 我知道了，关闭提示同时刷新申请列表
    var close = function close() {
      tip.value.close();
      getApplyList();
    };

    // 判断是不是移交管理员阶段
    var formAdmin = computed(function () {
      return mineStore.getFromAdmin;
    });
    var studentId = computed(function () {
      return mineStore.getStudentId;
    });

    // 关闭弹窗
    var closeDialog = function closeDialog() {
      if (state.applyBindList.length == 0) {
        dialog.value.close();
      }
      // 处理移交管理员时候的审核
      if (formAdmin.value) {
        refreshApplyList();
      } else {
        tip.value.open();
      }
    };
    // 同意
    var agree = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
        var _state$current_apply2, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              state.current_apply = data.val;
              _context.prev = 1;
              _context.next = 4;
              return applyDeal({
                applyId: (_state$current_apply2 = state.current_apply) === null || _state$current_apply2 === void 0 ? void 0 : _state$current_apply2.applyId,
                status: 2
              });
            case 4:
              res = _context.sent;
              console.log("同意申请", res);
              if (res.code == 0) {
                // 处理过，下一条
                state.applyBindList.splice(data.index, 1);
                closeDialog();
              }
              _context.next = 11;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }));
      return function agree(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    // 拒绝
    var reject = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
        var _state$current_apply3, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              state.current_apply = data.val;
              _context2.prev = 1;
              _context2.next = 4;
              return applyDeal({
                applyId: (_state$current_apply3 = state.current_apply) === null || _state$current_apply3 === void 0 ? void 0 : _state$current_apply3.applyId,
                status: 3
              });
            case 4:
              res = _context2.sent;
              if (res.code == 0) {
                // 处理过，下一条
                state.applyBindList.splice(data.index, 1);
                closeDialog();
              }
              _context2.next = 10;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      }));
      return function reject(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 申请列表
    var getApplyList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // 切换状态
              mineStore.setApplyStatus(false);
              _context3.prev = 1;
              _context3.next = 4;
              return applyList({
                studentId: studentId.value
              });
            case 4:
              res = _context3.sent;
              if (res.code == 0) {
                state.applyBindList = res.data.list;
                // 如果列表有，则弹窗
                if (state.applyBindList.length) {
                  dialog.value.open();
                }
              }
              _context3.next = 10;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 8]]);
      }));
      return function getApplyList() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 主管理员刷新申请列表
    var refreshApplyList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // 切换状态
              mineStore.setApplyStatus(false);
              _context4.prev = 1;
              _context4.next = 4;
              return applyList({
                studentId: studentId.value
              });
            case 4:
              res = _context4.sent;
              if (res.data.code == 0) {
                console.log("res", res);
                state.applyBindList = res.data.list;
                mineStore.setFromAdmin(false);
                // 如果列表有，则弹窗
                if (state.applyBindList.length) {
                  dialog.value.open();
                } else {
                  mineStore.setStudentId("");
                  Toast("遗留家长申请已处理，请您再次选择并移交管理员");
                }
              }
              _context4.next = 10;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 8]]);
      }));
      return function refreshApplyList() {
        return _ref4.apply(this, arguments);
      };
    }();
    watch(function () {
      return route.path;
    }, function (newval) {
      console.log("route1", newval);
      if (state.routes.indexOf(newval) > -1) {
        // 调用申请待审核列表接口
        getApplyList();
      }
    }, {
      immediate: true
    });
    watch(function () {
      return showApply.value;
    }, function (val) {
      if (val) {
        getApplyList();
      }
    });
    watch(function () {
      return accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.value;
    }, function (val) {
      if (!(val !== null && val !== void 0 && val.studentId)) {
        mineStore.setAccountInfo(getStorage(STORE_USERINFO_KEY));
      }
    }, {
      immediate: true
    });

    // 获取签名
    var getSign = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, _res$data, appId, timestamp, nonceStr, signature;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return jsapiSignature({
                url: window.location.href.split("#")[0]
              });
            case 3:
              res = _context5.sent;
              console.log("jssdk配置信息", res);
              // wx.ready()
              if (res.code == 0) {
                _res$data = res.data, appId = _res$data.appId, timestamp = _res$data.timestamp, nonceStr = _res$data.nonceStr, signature = _res$data.signature;
                console.log("微信初始化配置", {
                  appId: appId,
                  timestamp: timestamp,
                  nonceStr: nonceStr,
                  signature: signature
                });
                wx.config({
                  debug: false,
                  // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                  appId: appId,
                  // 必填，公众号的唯一标识
                  timestamp: timestamp,
                  // 必填，生成签名的时间戳
                  nonceStr: nonceStr,
                  // 必填，生成签名的随机串
                  signature: signature,
                  // 必填，签名
                  jsApiList: ["closeWindow", "updateTimelineShareData", "updateAppMessageShareData", "chooseImage", "uploadImage", "downloadImage", "getLocalImgData"],
                  // 必填，需要使用的 JS 接口列表
                  success: function success() {
                    console.log("微信初始化配置成功");
                  },
                  fail: function fail() {
                    console.log("微信初始化配置失败");
                  }
                });
              }
              _context5.next = 10;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 8]]);
      }));
      return function getSign() {
        return _ref5.apply(this, arguments);
      };
    }();
    onBeforeMount(function () {
      setTimeout(function () {
        getSign();
      }, 0);
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      var _component_ConfirmDialog = _resolveComponent("ConfirmDialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _createCommentVNode(" 账号管理申请popup "), _createVNode(ResponseBindApplyPopup, {
        ref_key: "dialog",
        ref: dialog,
        "apply-bind-list": state.applyBindList,
        onAgreeBind: agree,
        onRefuseBind: reject
      }, null, 8 /* PROPS */, ["apply-bind-list"]), _createCommentVNode(" 申请处理完毕提示框confirm "), _createVNode(_component_ConfirmDialog, {
        ref_key: "tip",
        ref: tip,
        onCancelEvent: close,
        onCloseDialog: close,
        onSureEvent: toLook,
        showClose: false,
        title: state.dialogOption.title,
        message: state.dialogOption.message,
        "cancel-text": state.dialogOption.cancelText,
        "sure-text": state.dialogOption.sureText
      }, {
        leftIcon: _withCtx(function () {
          return _cache[0] || (_cache[0] = [_createElementVNode("img", {
            src: _imports_0,
            alt: ""
          }, null, -1 /* HOISTED */)]);
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "message", "cancel-text", "sure-text"])], 64 /* STABLE_FRAGMENT */);
    };
  }
});